import React from 'react';
import PropTypes from 'prop-types';


import Label from "../../common/primitives/Label";

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from './img/remove.png';
import styles from "./CartLines.scss";
import Price, {ConvertToEUR} from "../../common/primitives/Price";
import LoadingRow from "../../common/primitives/LoadingRow";
import {__t} from '../../common/lang/text-resource';

const CartLineDomOther = ({data, removeService, showAsPage}) => {
	const {
		id,
		serviceName,
		serviceId,
		discountPriceList,
		discountPromo,
		discountTerm,
		term,
		oldPrice,
		price,
		priceOrig,
		currency,
		isNewService,
		isRenewService,
		canDelete,
		loading
	} = data;

	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}

	const showSecondRow = (discountPriceList > 0 || discountPromo > 0 || discountTerm > 0);
	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDelete === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt={__t("Remove")}/>
					</button>
				  }

			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={serviceName}
					title={serviceName}
					className={`${helpers.orderServiceName} ${!showAsPage ? styles.asPageServiceName : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
			  <div data-layout={`col 11 margin-top--xs padding-left--xs 6@md`}>
				  <table className={styles.selectedPriceContainer}>
					  <tbody>
					  <tr>
						  <td>&nbsp;</td>
						  <td className={styles.oldPrice}>
							  {
								  oldPrice !== price ? oldPrice : null
							  }
							  {SHVO.showEuroPrices && <>
								  <br/>
								  {
									  oldPrice !== price ? ConvertToEUR(oldPrice) : null
								  }
							  </>}
						  </td>
						  <td>
							  <Price
								currency={currency}
								value={priceOrig}
								currencyClass={styles.currency}/>
							  {SHVO.showEuroPrices && <>
								  <br/>
								  <Price
									currency={'EUR'}
									value={ConvertToEUR(priceOrig)}
									currencyClass={styles.currency}/>
							  </>}
						  </td>
					  </tr>
					  </tbody>
				  </table>
			  </div>
		  </div>

		  {
			  showSecondRow ?
				<div data-layout="row gutter-none start" className={styles.discountsWrapper}>
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*Редове с отстъпки начало*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					<div className={styles.rightAtTabPage} data-layout={`col 12 ${showAsPage ? '6@md' : ''}`}>

						{
							(discountPriceList > 0 && discountPromo < 100) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {__t('–-discountPriceList%-допълнителна-партньорска-отсbd47bc', {discountPriceList: discountPriceList})}
								  </div>
							  </div>
							  : ''
						}

						{
							(discountPromo > 0) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {__t('–:discountPromo% отстъпка от промокод', {discountPromo: discountPromo})}
								  </div>
							  </div>
							  : ''
						}

						{
							(discountTerm > 0 && discountPromo < 100) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {isRenewService ? __t('–:discountTerm% промоционална отстъпка', {discountTerm: discountTerm}) : __t('–:discountTerm% отстъпка за нова услуга', {discountTerm: discountTerm})}
								  </div>
							  </div>
							  : ''
						}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Редове с отстъпки край*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					</div>
					{
						showAsPage ? <div className={styles.removeContainer} data-layout="first@md"/> : ''
					}
					<div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}/>
				</div>
				: ''
		  }

	  </section>
	);

};
CartLineDomOther.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceTypeName: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceType: PropTypes.string.isRequired,
		discountPriceList: PropTypes.number,
		discountPromo: PropTypes.number,
		discountTerm: PropTypes.number,
		term: PropTypes.string,
		oldPrice: PropTypes.string,
		price: PropTypes.string,
		priceOrig: PropTypes.string,
		currency: PropTypes.string,
		isNewService: PropTypes.bool,
		isRenewService: PropTypes.bool,
		canDelete: PropTypes.bool,
	}),
	removeService: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool
};

export default CartLineDomOther;